import { apiDetailSolicitudesGenerales, apiValidarSolicitudesGenerales } from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";

import { enumProveedorStep } from "../settings/enumConfig";
import { getProveedoresFormSteps } from "../model/datosCompaniaModel";
import { routeRoot } from "../settings/routerConfig";
import { useEffect } from "react";
import { useHistory } from "react-router";
import { useRequest } from "./RequestContext";
import { useToken } from "./TokenContext";

export const ProveedoresProspectosContext = createContext();

export const ProveedoresProspectosProvider = (props) => {
    const { Get } = useRequest();
    const history = useHistory();
    const { handleChangeToken } = useToken();

    const [activeStep, setActiveStep] = useState(enumProveedorStep.DatosCompania);
    const [Extranjero, setExtranjero] = useState(true);
    const [provedoresSteps, setProvedoresSteps] = useState(getProveedoresFormSteps());
    const [editLoaderMessage, setEditLoaderMessage] = useState("Validando información...");
    const [solicitudProspectoID, setSolicitudProspectoID] = useState(0);
    const [entSolicitudDetalleForEdit, setEntSolicitudDetalleForEdit] = useState(null);

    const handleChangeProveedoresStep = (value) => {
        setProvedoresSteps(value);
    };

    const handleClickResetStepError = () => {
        setProvedoresSteps(provedoresSteps.map((x) => ({ ...x, error: false })));
    };

    const handleChangeStep = (value) => {
        setActiveStep(value);
    };

    const handleExtranjero = (value) => {
        setExtranjero(value);
    };

    const handleLoadSolicitudEdit = async (authparam) => {
        const response = await CValidateTokenEdit(authparam);
        if (response.Code === 0) {
            const { fiIdSolicitudProveedor, fcKey, fcToken } = response.Result;
            handleChangeToken(fcKey, fcToken);
            setEditLoaderMessage("Preparando formulario...");
            setSolicitudProspectoID(fiIdSolicitudProveedor);
        } else {
            history.push(routeRoot);
        }
    };

    const handleChangeSolcitudDetalleID = async () => {
        const response = await CGetSolicitudProspectoDetalle(solicitudProspectoID);
        if (response.Code === 0) {
            document.querySelector("title").innerHTML = "BEPENSA - Editar formulario de solicitud";
            setProvedoresSteps(
                provedoresSteps.map((x) => ({
                    ...x,
                    name: x.id === enumProveedorStep.EnviarSolicitud ? x.name3 : x.name,
                }))
            );
            window.onbeforeunload = function (e) {
                e.preventDefault();
                return "ok";
            };
            setEntSolicitudDetalleForEdit(response.Result);
        }
        history.push(routeRoot);
    };

    const CValidateTokenEdit = async (authparam) => {
        const payload = {
            url: apiValidarSolicitudesGenerales.replace("{authparam}", authparam),
        };

        return await Get(payload);
    };

    const CGetSolicitudProspectoDetalle = async (piIdSolicitudProveedor) => {
        const payload = {
            url: apiDetailSolicitudesGenerales.replace("{piIdSolicitudProveedor}", piIdSolicitudProveedor),
        };

        return await Get(payload);
    };

    useEffect(() => {
        if (solicitudProspectoID !== 0) {
            handleChangeSolcitudDetalleID();
        }
        // eslint-disable-next-line
    }, [solicitudProspectoID]);

    return (
        <ProveedoresProspectosContext.Provider
            value={{
                activeStep,
                provedoresSteps,
                entSolicitudDetalleForEdit,
                editLoaderMessage,
                Extranjero,
                handleClickResetStepError,
                handleChangeProveedoresStep,
                handleChangeStep,
                handleLoadSolicitudEdit,
                handleExtranjero,
            }}
        >
            {props.children}
        </ProveedoresProspectosContext.Provider>
    );
};

export const useProveedoresProspectos = function () {
    return useContext(ProveedoresProspectosContext);
};
